// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SbQp","left":"styles_left__3ByBq","right":"styles_right__1adRf","alert":"styles_alert__1RoCA"};